/** Indica si la respuesta tiene archivo o comentarios. */
export function hasEvidence(ans: any): boolean {
  if (ans?.fileId) return true;
  return hasCommentText(ans?.comments);
}

/** Indica si los comentarios tienen texto visible. */
function hasCommentText(comments: any): boolean {
  if (!comments) return false;
  return String(comments).trim() !== '';
}

/** Resuelve la evidencia requerida por la pregunta. */
export function evidenceNeeded(q: any, ans: any): string | null {
  if (missingQuestion(q)) return null;
  if (isFileQuestion(q)) return null;
  return configuredEvidence(q, ans);
}

/** Indica si la pregunta no exige evidencia. */
function missingQuestion(q: any): boolean {
  return !q || !q.evidenceRequired;
}

/** Indica si la pregunta espera un archivo directo. */
function isFileQuestion(q: any): boolean {
  return q.questionType?.dataType === 'file';
}

/** Resuelve la evidencia booleana o la configurada. */
function configuredEvidence(q: any, ans: any): string | null {
  if (hasBooleanEvidence(q)) return resolveBooleanEvidence(q, ans);
  return typedEvidence(q);
}

/** Indica si define evidencia por valor booleano. */
function hasBooleanEvidence(q: any): boolean {
  return Boolean(q.evidenceTrue || q.evidenceFalse);
}

/** Obtiene el tipo configurado o archivo por defecto. */
function typedEvidence(q: any): string | null {
  if (q.evidenceType) return q.evidenceType;
  return 'file';
}

/** Resuelve la evidencia según el valor sí o no. */
function resolveBooleanEvidence(q: any, ans: any): string | null {
  return booleanAnswerEvidence(q, ans?.answer);
}

/** Obtiene la evidencia para el valor booleano dado. */
function booleanAnswerEvidence(q: any, value: any): string | null {
  if (value === 'true') return q.evidenceTrue;
  if (value === 'false') return q.evidenceFalse;
  return null;
}

/** Indica si la respuesta tiene valor válido. */
export function isValidAnswer(ans: any): boolean {
  return validText(ans?.answer);
}

/** Valida el valor de respuesta como texto. */
function validText(value: any): boolean {
  if (value == null) return false;
  return textAccepted(String(value).trim());
}

/** Acepta el texto no vacío distinto de falso. */
function textAccepted(text: string): boolean {
  return text !== '' && text !== 'false';
}

/** Calcula los puntos mensuales con evidencia parcial. */
export function monthPoints(q: any, ans: any): number {
  if (!isValidAnswer(ans)) return 0;
  return scoredNeed(evidenceNeeded(q, ans), ans);
}

/** Puntúa según la evidencia requerida y aportada. */
function scoredNeed(need: string | null, ans: any): number {
  if (optionalEvidence(need)) return 1;
  return hasEvidence(ans) ? 1 : 0.5;
}

/** Indica si la evidencia es opcional o innecesaria. */
function optionalEvidence(need: string | null): boolean {
  return !need || need === 'none';
}
